import { useEffect, useRef } from "react";
import { ASSETS, Chapter } from "../presentation";

const HERO_START = 2;

export default function S01Cover() {
  const wrapRef = useRef(null);
  const videoRef = useRef(null);

  const onMeta = (e) => {
    const v = e.currentTarget;
    if (v.duration && v.duration > HERO_START + 0.2) v.currentTime = HERO_START;
  };
  const onEnded = (e) => {
    const v = e.currentTarget;
    v.currentTime = HERO_START;
    const p = v.play();
    if (p && typeof p.catch === "function") p.catch(() => {});
  };

  useEffect(() => {
    if (typeof window === "undefined") return undefined;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const wrap = wrapRef.current;
    const video = videoRef.current;
    let raf = 0;
    const onScroll = () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = 0;
        if (!wrap || !video) return;
        const rect = wrap.getBoundingClientRect();
        const total = rect.height - window.innerHeight;
        const scrolled = Math.min(Math.max(-rect.top, 0), total);
        const p = total > 0 ? scrolled / total : 0;
        video.style.transform = `translate3d(0, ${p * -30}px, 0) scale(${1 + p * 0.05})`;
        const inner = wrap.querySelector(".cover-inner");
        if (inner) {
          inner.style.transform = `translateY(${p * 44}px)`;
          inner.style.opacity = String(1 - p * 0.55);
        }
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => {
      window.removeEventListener("scroll", onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <div className="cover-wrap" ref={wrapRef} id="cover">
      <section className="cover" data-testid="slide-cover">
        <video
          ref={videoRef}
          className="cover-video"
          src={ASSETS.coverVideo}
          poster={ASSETS.coverPoster}
          autoPlay
          loop
          muted
          playsInline
          onLoadedMetadata={onMeta}
          onEnded={onEnded}
          data-testid="cover-video"
        />
        <div className="cover-veil" />
        <div className="cover-grain" />

        <div className="cover-inner">
          <div className="cover-topbar">
            <Chapter ch="01" label="press conference" testid="cover-chapter" />
          </div>

          <div className="cover-body">
            <div className="cover-logos" data-testid="cover-logos">
              <h1 className="cover-wordmark" data-testid="cover-wordmark">SUNREEF</h1>
              <span className="cover-logos-divider" aria-hidden="true" />
              <img
                className="cover-cyf"
                src={ASSETS.cyfLogo}
                alt="Cannes Yachting Festival"
                data-testid="cover-cyf-logo"
              />
            </div>
            <p className="cover-tagline" data-testid="cover-tagline">
              Breakfast &amp; Briefing <span className="gold">September 9th, Vieux Port, Cannes.</span>
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
